import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import "./Timeline.css"

export default function OppositeContentTimeline() {
	return (
		<React.Fragment>
			<Timeline position="right">
				<TimelineItem>
					<TimelineSeparator>
						<TimelineDot />
						<TimelineConnector />
					</TimelineSeparator>
					<TimelineContent>
						<div className="text-container">
							<div className="timeline-date">Sept 2018 - Jan 2023</div>
							<br></br>
							<div className="timeline-event">Computer Science @ University of Calgary</div>
							<div className="timeline-location">Calgary, AB, CA</div>
							<br></br>
						</div>
					</TimelineContent>
				</TimelineItem>


				<TimelineItem>
					<TimelineSeparator>
						<TimelineDot />
						<TimelineConnector />
					</TimelineSeparator>
					<TimelineContent className="text-container">
						<div className="timeline-date">Mar 2023 - Oct 2023</div>
						<br></br>
						<div className="timeline-event">Data Engineer @ AI Financial</div>
						<div className="timeline-location">Toronto, ON, CA</div>
						<br></br>
					</TimelineContent>
				</TimelineItem>


				<TimelineItem>
					<TimelineSeparator>
						<TimelineDot />
						<TimelineConnector />
					</TimelineSeparator>
					<TimelineContent className="text-container">
						<div className="timeline-date">Jan 2024 - Apr 2024</div>
						<br></br>
						<div className="timeline-event">SDE @ Interact Health Pro</div>
						<div className="timeline-location">Toronto, ON, CA </div>
						<br></br>
					</TimelineContent>
				</TimelineItem>


				<TimelineItem>
					<TimelineSeparator>
						<TimelineDot />
						<TimelineConnector />
					</TimelineSeparator>
					<TimelineContent className="text-container">
						<div className="timeline-date">July 2024 - July 2025</div>
						<br></br>
						<div className="timeline-event">Research Assistant @ University of Calgary</div>
						<div className="timeline-location">Calgary, AB, CA</div>
						<br></br>
					</TimelineContent>
				</TimelineItem>


				<TimelineItem>
					<TimelineSeparator>
						<TimelineDot />
					</TimelineSeparator>
					<TimelineContent className="text-container">
						<div>To be continued...</div>
					</TimelineContent>
				</TimelineItem>
			</Timeline>
		</React.Fragment>
	);
}